/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateFiservApplicationRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FiservApplicationResponse } from '../models';
// @ts-ignore
import type { FiservProcessingPlansResponse } from '../models';
/**
 * FiservBoardingApi - axios parameter creator
 * @export
 */
export const FiservBoardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
         * @summary Create a Fiserv Forward boarding application for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiservApplication: async (merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createFiservApplication', 'merchantId', merchantId)
            const localVarPath = `/api/v1/merchants/{merchantId}/fiserv/applications`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFiservApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the status and details of a Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiservApplication: async (merchantId: string, applicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getFiservApplication', 'merchantId', merchantId)
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('getFiservApplication', 'applicationId', applicationId)
            const localVarPath = `/api/v1/merchants/{merchantId}/fiserv/applications/{applicationId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the FanFair-level processing-plan catalogue from `fiserv.processingPlans`. Backed by application config (SSM / Terraform env vars), populated per environment via the manual Forward Bootstrap Runbook. NOT a per-partner Forward `GET /processing_plans` proxy. Used by the Admin UI to render the plan-selection dropdown when boarding a merchant. 
         * @summary List FanFair\'s configured Fiserv Forward processing plans (catalogue)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiservProcessingPlans: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/fiserv/processing-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiservBoardingApi - functional programming interface
 * @export
 */
export const FiservBoardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FiservBoardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
         * @summary Create a Fiserv Forward boarding application for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFiservApplication(merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiservApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFiservApplication(merchantId, createFiservApplicationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.createFiservApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the status and details of a Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiservApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiservApplication(merchantId, applicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.getFiservApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the FanFair-level processing-plan catalogue from `fiserv.processingPlans`. Backed by application config (SSM / Terraform env vars), populated per environment via the manual Forward Bootstrap Runbook. NOT a per-partner Forward `GET /processing_plans` proxy. Used by the Admin UI to render the plan-selection dropdown when boarding a merchant. 
         * @summary List FanFair\'s configured Fiserv Forward processing plans (catalogue)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFiservProcessingPlans(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiservProcessingPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFiservProcessingPlans(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FiservBoardingApi.listFiservProcessingPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FiservBoardingApi - factory interface
 * @export
 */
export const FiservBoardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FiservBoardingApiFp(configuration)
    return {
        /**
         * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
         * @summary Create a Fiserv Forward boarding application for a merchant
         * @param {string} merchantId Merchant identifier
         * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiservApplication(merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<FiservApplicationResponse> {
            return localVarFp.createFiservApplication(merchantId, createFiservApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the status and details of a Fiserv boarding application
         * @param {string} merchantId Merchant identifier
         * @param {string} applicationId Fiserv application identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FiservApplicationResponse> {
            return localVarFp.getFiservApplication(merchantId, applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the FanFair-level processing-plan catalogue from `fiserv.processingPlans`. Backed by application config (SSM / Terraform env vars), populated per environment via the manual Forward Bootstrap Runbook. NOT a per-partner Forward `GET /processing_plans` proxy. Used by the Admin UI to render the plan-selection dropdown when boarding a merchant. 
         * @summary List FanFair\'s configured Fiserv Forward processing plans (catalogue)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFiservProcessingPlans(options?: RawAxiosRequestConfig): AxiosPromise<FiservProcessingPlansResponse> {
            return localVarFp.listFiservProcessingPlans(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FiservBoardingApi - object-oriented interface
 * @export
 * @class FiservBoardingApi
 * @extends {BaseAPI}
 */
export class FiservBoardingApi extends BaseAPI {
    /**
     * Creates a new Fiserv Forward boarding application for the specified merchant. Pre-fills the application with merchant data (business details, address, owner info) and returns a hosted application URL for the merchant to complete onboarding. 
     * @summary Create a Fiserv Forward boarding application for a merchant
     * @param {string} merchantId Merchant identifier
     * @param {CreateFiservApplicationRequest} [createFiservApplicationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public createFiservApplication(merchantId: string, createFiservApplicationRequest?: CreateFiservApplicationRequest, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).createFiservApplication(merchantId, createFiservApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the status and details of a Fiserv boarding application
     * @param {string} merchantId Merchant identifier
     * @param {string} applicationId Fiserv application identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public getFiservApplication(merchantId: string, applicationId: string, options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).getFiservApplication(merchantId, applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the FanFair-level processing-plan catalogue from `fiserv.processingPlans`. Backed by application config (SSM / Terraform env vars), populated per environment via the manual Forward Bootstrap Runbook. NOT a per-partner Forward `GET /processing_plans` proxy. Used by the Admin UI to render the plan-selection dropdown when boarding a merchant. 
     * @summary List FanFair\'s configured Fiserv Forward processing plans (catalogue)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiservBoardingApi
     */
    public listFiservProcessingPlans(options?: RawAxiosRequestConfig) {
        return FiservBoardingApiFp(this.configuration).listFiservProcessingPlans(options).then((request) => request(this.axios, this.basePath));
    }
}

